import { useEffect, useRef } from 'react';

export const useTimeout = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the timeout.
  useEffect(() => {
    function run() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setTimeout(run, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}